import * as S from "./styles";

import { ProductRegion } from "contexts/register/ClientContext";
import { treatCurrencyDisplay } from "utils/treatCurrencyDisplay";

import { ReactComponent as TrashIcon } from "assets/delete.svg";

type Props = {
  region: ProductRegion;
  onClose: () => void;
};

export function RegionTag({ region, onClose }: Props) {
  return (
    <S.Wrapper>
      <S.Row>
        <h4>{region.name}</h4>
        <button type="button" title="Excluir região" onClick={() => onClose()}>
          <TrashIcon />
        </button>
      </S.Row>
      <S.Row>
        <span>Valor por região</span>
        <span>R${treatCurrencyDisplay(region.regionValue)}</span>
      </S.Row>
      <S.Row>
        <span>Valor por hora adicional</span>
        <span>R${treatCurrencyDisplay(region.hourValue)}</span>
      </S.Row>
      <S.Row>
        <span>Valor por KM adicional</span>
        <span>R${treatCurrencyDisplay(region.kmValue)}</span>
      </S.Row>
    </S.Wrapper>
  );
}
